var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2736_2584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9148 6.34565C23.4961 3.36389 21.8569 1.31112 19.1886 0.397118C16.5985 -0.486921 14.1502 0.134903 12.1135 2.20266C12.071 2.24761 12.0355 2.29256 12 2.33751C11.9148 2.22513 11.8226 2.12024 11.7232 2.01536C10.3111 0.584414 8.35245 -0.134804 6.35126 0.0524926C4.35718 0.232297 2.5476 1.29614 1.39089 2.96682C-0.70255 5.97855 -0.404502 9.94174 2.10052 12.5939C4.40685 15.0362 6.72028 17.4711 9.0337 19.9059L11.56 22.558C11.6097 22.6105 11.6594 22.6554 11.7232 22.7079L12.0426 22.9926L12.369 22.6629C12.4329 22.5955 12.4967 22.5356 12.5535 22.4756L15.2076 19.6737C17.4571 17.2987 19.7138 14.9238 21.9562 12.5339C23.5955 10.7883 24.2555 8.70559 23.9148 6.33067V6.34565ZM22.2401 8.25608C22.0556 9.4323 21.5446 10.4662 20.7357 11.3202L12.0071 20.5352L11.9574 20.4828C11.7516 20.258 11.5458 20.0333 11.34 19.816L9.14724 17.501C7.22412 15.4707 5.301 13.4404 3.36368 11.4176C1.27734 9.23751 1.14961 5.79875 3.07273 3.59614C4.05913 2.47236 5.38616 1.82806 6.81253 1.7906C6.85511 1.7906 6.89769 1.7906 6.94026 1.7906C8.33825 1.7906 9.66528 2.37497 10.6872 3.43881C10.9213 3.68604 11.1555 3.93327 11.411 4.21047L12.0355 4.87725L12.2909 4.59256C12.4329 4.43523 12.5606 4.28539 12.6954 4.13555C12.958 3.83588 13.2064 3.5437 13.476 3.28148C15.0869 1.68572 17.5636 1.3336 19.5009 2.42741C21.5092 3.56617 22.6091 5.90363 22.2401 8.25608Z",
    fill: "#464646"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2736_2584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.3177b77243d1119745a18ad2a65b7341.svg";
export { ForwardRef as ReactComponent };